export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7052.32a031f8.jpg";